import "@babel/polyfill";
import Vue from "vue";
import axios from "./modules/axios";
import "@/assets/style/style.scss";

import vBrandSlider from "./components/BrandSlider.vue";
import vProductGrid from "./components/ProductGrid.vue";

import "./components/newsletter";

Vue.prototype.$http = axios;

const instances = [vBrandSlider, vProductGrid];

instances.forEach((instance) => {
  const elements = Array.prototype.slice.call(
    document.querySelectorAll(instance.selector)
  );

  elements.forEach(
    (el) =>
      new Vue({
        ...instance,
        el,
        // takes data attributes (data-*) on the root element and parses them as props
        propsData: Object.entries(el.dataset).reduce(
          (sum, [key, val]) => ({
            ...sum,
            get [key]() {
              try {
                return JSON.parse(val);
              } catch (err) {
                return val;
              }
            },
          }),
          {}
        ),
      })
  );
});
